module.exports = __webpack_public_path__ + "static/media/logo_oceanbank.61663dfb.svg";